import React, { createContext, useContext, useState, ReactNode } from 'react';

type AuthFlowMessage = {
  type: 'success' | 'error' | 'info';
  text: string;
} | null;

type AuthFlowState = {
  message: AuthFlowMessage;
  isRedirecting: boolean;
  setMessage: (message: AuthFlowMessage) => void;
  setIsRedirecting: (redirecting: boolean) => void;
};

const AuthFlowContext = createContext<AuthFlowState | null>(null);

export const useAuthFlow = () => {
  const ctx = useContext(AuthFlowContext);
  if (!ctx) {
    throw new Error('useAuthFlow must be used within AuthFlowProvider');
  }
  return ctx;
};

export const AuthFlowProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [message, setMessage] = useState<AuthFlowMessage>(null);
  const [isRedirecting, setIsRedirecting] = useState(false);

  return (
    <AuthFlowContext.Provider value={{ message, isRedirecting, setMessage, setIsRedirecting }}>
      {children}
    </AuthFlowContext.Provider>
  );
};
